import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NewsCard from '../../components/news/NewsCard';
import { newsService } from '../../services/newsService';
import { FALLBACK_NEWS } from '../../services/fallbackData';

export default function NewsListPage() {
  const [news, setNews] = useState(FALLBACK_NEWS);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    newsService
      .getPublicNews()
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setNews(res.data);
        }
      })
      .catch(() => {});
  }, []);

  const categories = ['all', ...new Set(news.map((n) => n.category).filter(Boolean))];

  const filteredNews = activeCategory === 'all'
    ? news
    : news.filter((n) => n.category === activeCategory);

  return (
    <div>
      <section className="page-hero">
        <div className="container">
          <div className="crumb">
            <Link to="/">Trang chủ</Link> / <span>Tin tức &amp; Sự kiện</span>
          </div>
          <span className="eyebrow">Cập nhật từ Thế Thảo</span>
          <h1>
            Tin tức &amp; Câu chuyện
            <br />
            từ ngành dược.
          </h1>
          <p className="lead">
            Chia sẻ kiến thức pháp lý, xu hướng marketing nhà thuốc, hành trình của đội ngũ — và những câu chuyện đáng nhớ từ chương trình Tủ Thuốc Cho Em.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Category Filter Pills */}
          {categories.length > 2 && (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '32px' }}>
              {categories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setActiveCategory(cat)}
                  className={`btn ${activeCategory === cat ? 'btn--primary' : 'btn--ghost'}`}
                  style={{ padding: '8px 18px', fontSize: '0.9rem', borderRadius: '20px' }}
                >
                  {cat === 'all' ? 'Tất cả tin' : cat}
                </button>
              ))}
            </div>
          )}

          <div className="news-grid">
            {filteredNews.map((item, idx) => (
              <NewsCard key={item.id} item={item} index={idx} />
            ))}
          </div>

          {filteredNews.length === 0 && (
            <p className="muted" style={{ textAlign: 'center', padding: '40px 0' }}>
              Chưa có bài viết nào trong danh mục này.
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
